const dictionary = {
  by: 'By',
  the: 'The',
  of: 'Of',
  start: 'Start',
  end: 'End',
  error: 'Error',
  done: 'Done',
  save: 'Save',
  confirm: 'Confirm',
  save_and_confirm: 'Save & Confirm',
  delete: 'Delete',
  reset: 'Reset',
  search: 'Search',
  sort: 'Sort',
  find: 'Find',
  rows: 'Rows',
  data: 'Data',
  value: 'Value',
  copy: 'Copy',
  copied: 'copied',
  created_at: 'Created at',
  updated_at: 'Updated at',
  status: 'Status',
  not_found: 'Not Found',
  current: 'Current',
  information_abbr: 'info',
  information: 'Information',
  save_success_message: 'saved successfully',
  update_success_message: 'updated successfully',
  confirm_success_message: 'confirmed successfully',
  completed_success_message: 'completed successfully',
  deleted_success_message: 'deleted successfully',
  is_required: 'is required',
  is_greater_than: 'is greater than',
  must_be_greater_than_zero: 'must be greater than 0',
  send: 'Send',
  new: 'New',
  add: 'Add',
  edit: 'Edit',
  view: 'View',
  remove: 'Remove',
  clear: 'Clear',
  more: 'More',
  sure_message: 'Are you sure?',
  remove_confirmation_message: 'Are you sure to remove',
  remove_success_message: 'removed successfully',
  delete_success_message: 'deleted successfully',
  yes: 'Yes',
  no: 'No',
  ok: 'OK',
  cancel: 'Cancel',
  exit: 'Exit',
  not_now: 'Not Now',
  continue: 'Continue',
  type: 'Type',
  select: 'Select',
  title: 'Title',
  description: 'Description',
  show: 'Show',
  settings: 'Settings',
  missing_field_message: 'Missing',
  wrong_message: 'Wrong',
  sure_to: 'Sure to',
  sure_to_cancel: 'Sure to cancel?',
  dashboard: 'Dashboard',
  appraisal: 'Appraisal',
  inventory: 'Inventory',
  order: 'Order',
  ordered: 'Ordered',
  orders: 'Orders',
  wedding_registry: 'Registry',
  wedding_number_abbr: 'Wedding No.',
  login_fail_message: 'Wrong Credentials',
  log_in: 'Log in',
  log_out: 'Log Out',
  welcome_back: 'Welcome back!',
  name: 'Name',
  full_name: 'Full name',
  name_required_message: 'Please input your Name!',
  date: 'Date',
  detail: 'Detail',
  change_name: 'Change name',
  change_name_success_message: 'Your name changed successfully!',
  email: 'Email',
  password: 'Password',
  email_required_message: 'Please input your Email!',
  email_invalid_message: 'Email is invalid!',
  password_required_message: 'Please input your Password!',
  invalid_email_or_password: 'Invalid username or password',
  please_enter: 'Please enter',
  remember_me: 'Remember me',
  forgot_password: 'Forgot password',
  reset_password: 'Reset password',
  next: 'Next',
  previous: 'Previous',
  signup_fail_message: 'Wrong Signup',
  signup: 'Sign up',
  create_your_account: 'Create your account!',
  activate: 'Activate',
  activate_your_account_message: 'Please enter a code that sent to your email!',
  activation_success_message: 'Activation has done successfully',
  code: 'code',
  code_require_message: 'Please input your Code!',
  repeat_password: 'Repeat password',
  reset_password_fail_message: 'Wrong Reset password',
  reset_password_success_message: 'Your password changed successfully !',
  repeat_password_required_message: 'Please input your Repeat password!',
  password_and_repeat_password_are_not_equal:
    'Password and Repeat password are not equal',
  change_password: 'Change password',
  change_password_fail_message: 'Wrong change password',
  save_password: 'Save password',
  enter_password: 'Enter Password',
  incorrect_password_message: 'Incorrect password. Please try again.',
  already_have_an_account: 'Already have an account ?',
  dont_have_an_account: 'Don’t have an account ?',
  profile: 'Profile',
  id: 'Id',
  ID: 'ID',
  prefix: 'Prefix',
  first_name: 'First name',
  last_name: 'Last name',
  prefix_required_message: 'Please select Prefix!',
  first_name_required_message: 'Please input First name!',
  last_name_required_message: 'Please input Last name!',
  products: 'Products',
  quantities: 'Quantities',
  reports: 'Reports',
  design: 'Design',
  entry_fail_message: 'Wrong',
  contact_entry_fail_message: 'Wrong Customer',
  remove_customer: 'Remove customer',
  remove_customer_success_question: 'Are your sure to remove customer?',
  remove_customer_success_message: 'The customer removed successfully',
  created_by: 'Created by',
  contact: 'Contact',
  contacts: 'Contacts',
  contact_id: 'Contact ID',
  vendor: 'Vendor',
  customer: 'Customer',
  allow_contact: 'No Calendar',
  gender: 'Gender',
  company: 'Company',
  date_of_birth: 'Date of birth',
  anniversary: 'Anniversary',
  country_code: 'Country code',
  category: 'Category',
  subcategory: 'Sub Category',
  subcategory2: 'Sub Category 2',
  categories: 'Categories',
  category_already_exists_message: 'A category with this title already exists',
  subcategory_already_exists_message: 'A sub category with this title already exists under this category',
  subcategory2_already_exists_message: 'A sub category 2 with this title already exists under this sub category',
  duplicate_title_not_allowed: 'Duplicate title not allowed',
  phone: 'Phone',
  number: 'Number',
  number_abbr: 'No',
  address: 'Address',
  home_phone_short: 'Home',
  cell_phone_short: 'Cell',
  registry_number: 'Registry No',
  fax: 'Fax',
  extension_abbr: 'Ext',
  do_not_send_calendar: 'Do not send calendar',
  country: 'Country',
  state: 'State',
  city: 'City',
  street: 'Street',
  zip_code: 'Zip code',
  note: 'Note',
  notes: 'Notes',
  website: 'Website',
  seo: 'SEO',
  meta_title: 'Meta Title',
  meta_description: 'Meta Description',
  contact_group: 'Contact Group',
  contact_groups: 'Contact Groups',
  group: 'Group',
  group_id: 'Group ID',
  contact_category: 'Contact Category',
  contact_categories: 'Contact Categories',
  save_contact_category_success_message:
    'The Contact Category saved successfully',
  order_number_abbr: 'Order No',
  order_info: 'Order info',
  web_info: 'Web info',
  similar_contact_message:
    'The Contact is similar to the following contacts. Would you like to link them?',
  contact_links: 'Contact Links',
  ship: 'Ship',
  ship_to_same: 'Ship to same',
  item_category: 'Item category',
  item: 'Item',
  items: 'Items',
  item_number_abbr: 'Item No.',
  quantity_abbr: 'Qty',
  quantity_desired: 'Quantity Desired',
  price: 'Price',
  unit_price: 'Unit price',
  unit_cost: 'Unit cost',
  cost_price: 'Cost price',
  extended: 'Extended',
  quantity_available: 'Quantity Available',
  total_price: 'Total price',
  purchase: 'Purchase',
  purchase_order: 'Purchase order',
  purchase_order_abbr: 'PO',
  receivables: 'Receivables',
  repair_abbr: 'REP',
  repair: 'Repair',
  take_with_abbr: 'T.W',
  back_order_abbr: 'B.O.',
  amount: 'Amount',
  amounts: 'Amounts',
  freight: 'Freight',
  total: 'Total',
  total_payments_abbr: 'Total .Pay',
  balance: 'Balance',
  tax: 'Tax',
  last_pay: 'Last pay',
  last_pay_date: 'Last pay date',
  payment: 'Payment',
  special_instruction: 'Special Instruction',
  special: 'Special',
  completion: 'Completion',
  pick: 'Pick',
  expected: 'Expected',
  disposition: 'Disposition',
  storage: 'Storage',
  version: 'Version',
  exact_match: 'Exact Match',
  web_site: 'Web Site',
  watch: 'Watch',
  jewelery: 'Jewelry',
  Jewelery: 'Jewelry',
  giftware: 'Giftware',
  sku: 'SKU',
  sku_not_found: 'The SKU was not found',
  style: 'Style',
  pattern: 'Pattern',
  style_pattern: 'Style/Pattern',
  catalog: 'Catalog',
  online: 'Online',
  mounting: 'Mounting',
  cost: 'Cost',
  list: 'List',
  listing: 'Listing',
  store: 'Store',
  on_hand: 'On Hand',
  on_order: 'On Order',
  display: 'Display',
  back_order: 'Back Order',
  min: 'Min',
  max: 'Max',
  from: 'From',
  to: 'To',
  committed: 'Committed',
  quantity: 'Quantity',
  image: 'Image',
  images: 'Images',
  upload_image_message: 'Drag and drop images or Browse',
  upload_image_sub_message: 'Max 10MB each',
  upload: 'Upload',
  upload_more: 'Upload more',
  upload_empty_message: 'You have not uploaded anything yet',
  uploading: 'Uploading',
  estate: 'Estate',
  weight_gr: 'Weight GR',
  weight_pw: 'Weight PW',
  labor_cost: 'Labor Cost',
  width: 'Width',
  length: 'Length',
  height: 'Height',
  ring_size: 'Ring size',
  serial_number_abbr: 'Serial No.',
  color: 'Color',
  case_color: 'Case color',
  case_number_abbr: 'Case No.',
  band: 'Band',
  face_color: 'Face Color',
  material: 'Material',
  movement: 'Movement',
  dial: 'Dial',
  shape: 'Shape',
  crystal: 'Crystal',
  china: 'China',
  discontinued: 'Discontinued',
  stone: 'Stone',
  stones: 'Stones',
  cert_number_abbr: 'Cert. No',
  parcel_number: 'Parcel no',
  average_weight: 'Average size',
  average_weight_abbr: 'Average wgt',
  total_weight: 'Total weight',
  total_weight_abbr: 'Total wgt',
  number_of_pieces: 'No of pieces',
  carats_uppr: 'CARATS',
  industry_color_code: 'Industry color code',
  color_code: 'Color code',
  cost_ct: 'Cost/Ct',
  price_ct: 'Price/Ct',
  industry_clarity_code: 'Industry clarity code',
  clarity: 'Clarity',
  clarity_code: 'Clarity code',
  rap: 'Rap',
  off: 'Off',
  memo: 'Memo',
  mount: 'Mount',
  sale: 'Sale',
  sales: 'Sales',
  salesman: 'SalesMan',
  year_to_date: 'Year to Date',
  last_year_to_date: 'Last Year',
  includes_the_related_groups: 'Includes the related groups?',
  account: 'Account',
  markup: 'Markup',
  report_file: 'Report file',
  report: 'Report',
  print: 'Print',
  designer: 'Designer',
  viewer: 'Viewer',
  percent_off: 'Percent off',
  promotion: 'Promotion',
  relations: 'Relations',
  relation: 'Relation',
  client: 'Client',
  appraiser: 'Appraiser',
  appraisers: 'Appraisers',
  line: 'Line',
  lines: 'Lines',
  parcel: 'Parcel',
  ours: 'Ours',
  in_set: 'In Set',
  component: 'Component',
  components: 'Components',
  lady: 'Lady',
  gentleman: 'Gentleman',
  chain_type: 'Chain type',
  clasp: 'Clasp',
  finger_size: 'Finger size',
  fore_color: 'For color',
  cut: 'Cut',
  make: 'Make',
  certificate: 'Certificate',
  certification: 'Certification',
  certification_abbr: 'Cert',
  carets: 'Carats',
  measurements: 'Measurements',
  lab: 'Lab',
  depht: 'Depth',
  table: 'Table',
  gridle: 'Gridle',
  culet: 'Culet',
  polish: 'Polish',
  synmetry: 'Symmetry',
  fluorecence: 'Fluorescence',
  vrn_package: 'VRN Package',
  discounted: 'Discontinued',
  tableware: 'Tableware',
  marketing: 'Marketing',
  many: 'Many',
  dollars: 'Dollars',
  sold: 'Sold',
  purchase_date_abbr: 'Date Pur.',
  pattern_number_abbr: 'Pattern No.',
  sequence: 'Sequence',
  mounts: 'Mounts',
  carats: 'Carats',
  dimensions: 'Dimensions',
  bride_groom: 'Bride/Groom',
  payment_method: 'MOP',
  card_number: 'Card No',
  card_expire_month: 'Exp. Month',
  card_expire_year: 'Exp. Year',
  authorization: 'Authorization',
  payments: 'Payments',
  city_state_zip: 'City/St/Zip',
  taxable: 'Taxable',
  number_not_found: 'The number not found',
  registry_no: 'Registry No',
  event_date: 'Event Date',
  pre_order: 'Pre_Order',
  customer_no: 'CustomerNo',
  Appraisal_no: 'AppraisalNo',
  Clerk: 'Clerk',
  spouse_2: 'Spouse # 2',
  NameFirst: 'Name-First',
  Last: 'Last',
  Phone: 'Phone',
  eMail: 'eMail',
  click_to_download: 'Click to download',
  in_stock_only: 'In Stock Only',
  in_stock: 'In-stock',
  out_of_stock: 'Out of stock',
  onlines: 'Onlines',
  offlines: 'Offlines',
  show_pictures: 'Show Pictures',
  manufacture: 'Manufacture',
  management: 'Management',
  export_to_excel: 'Export to Excel',
  copy_item_confirmation: 'Are you sure to copy the current item ?',
  upload_images: 'Upload Images',
  upload_videos: 'Upload Videos',
  video: 'Video',
  topic: 'Topic',
  shop: 'Shop',
  webhooks: 'Webhooks',
  logs: 'Logs',
  play: 'Play',
  pause: 'Pause',
  details: 'Details',
  printer: 'Printer',
  ip: 'IP',
  port: 'Port',
  request: 'Request',
  template_type: 'Template type',
  label: 'Label',
  created_on: 'Create on',
  created_date: 'Created Date',
  processed_on: 'Processed on',
  finished_on: 'Finished on',
  update_items: 'Update items',
  attempts_made: 'attempts Made',
  input: 'Input',
  result: 'Result',
  retry: 'Retry',
  jobs: 'Jobs',
  ascending_abbr: 'ASC',
  descending_abbr: 'DESC',
  order_repair_item_description: 'REPAIR/ORDER',
  tag: 'Tag',
  new_print: 'New Print',
  new_report: 'New Report',
  clerk: 'Clerk',
  payment_type_report_title: 'Payment Type Detail Report',
  credit_card_report_title: 'Credit Card Detail Report',
  removing_repair_confirmation: 'Are you sure you want to remove the repair ?',
  work: 'Work',
  appointments: 'Appointments',
  service_type: 'Service Type',
  service_types: 'Service Types',
  service_type_unknown: 'Unknown',
  service_type_show_deleted: 'Show deleted',
  service_type_deleted: 'Deleted',
  service_type_restore: 'Restore',
  appointment_volume: 'Appointment Volume',
  service_type_distribution: 'Service Type Distribution',
  filter_by_service_type: 'Filter by service type',
  weekly: 'Weekly',
  monthly: 'Monthly',
  no_data_available: 'No data available',
  when: 'When',
  additional_info: 'Additional Info',
  save_parent_contact_message: 'You must save the parent contact beforehand',
  save_record_first_for_relations_message: "Save your new record first, then you'll be able to add relations.",
  remove_relation_success_message: 'The relation removed successfully',
  relation_already_exists_message: 'This contact is already linked as a relation',
  contact_already_in_another_relation_message: 'This contact is already linked to another contact as a relation',
  no_matching_contacts: 'No matching contacts — a new contact will be created on save',
  type_to_search_contacts: 'Type a contact ID, name, or phone to search',
  search_contact_placeholder: 'Search contact or type new ID',
  linked_to_existing_contact: 'Linked to an existing contact',
  history: 'History',
  level: 'Level',
  reply: 'Reply',
  replied: 'Replied',
  legacy: 'Legacy',
  new_arrivals: 'New Arrivals',
  admin: 'Admin',
  upload_format: 'Wrong format for upload',
  sent: 'Sent',
  used: 'Used',
  subject: 'Subject',
  text: 'Text',
  total_files: 'Total Files',
  add_to_image_list: 'Add to image list',
  no_images: 'No Images',
  different_file_names: 'Different file names',
  persisted: 'Persisted',
  uploaded: 'Uploaded',
  duplicated_file_names: 'Duplicated file names',
  replace_new_images: 'Replace with new images',
  invalid_skus: 'Invalid skus',
  upload_one: 'Upload One',
  mass_upload: 'Mass Upload',
  file_name: 'File Name',
  changes: "Changes",
  mass_changes: "Mass Changes",
  apply: "Apply",
  applying: "Applying",
  on_web: "Web",
  massChangeConfirmation:
    "Are you sure you want to apply the changes to the selected items?",
  image_slider: 'Image Slider',
  banner: 'Banner',
  banner_save_success_message: 'Banner saved successfully',
  banner_delete_success_message: 'Banner deleted successfully',
  banner_update_priority_success_message: 'Banner priority updated successfully',
  product: 'Product',
  selection: 'Selection',
  review: 'Review',
  back: 'Back',
  replenishment: 'Replenishment',
  custom: 'Custom',
  entry: 'Entry',
  date_range: 'Date Range',
  actions: 'Actions',
  skus: 'SKUs',
  quantity_needed: 'Quantity Needed',
  calculate: 'Calculate',
  source: 'Source',
  create: 'Create',
  add_new_value: 'Add new value',
  min_characters: 'Enter at least 3 characters',
  value_already_exists: 'Value already exists',
  purchase_order_id_abbr: 'PO ID',
  purchase_order_nu_abbr: 'P.O. Number',
  advanced: 'Advanced',
  get_report: 'Get Report',
  couple: 'Couple',
  supplier: 'Supplier',
  summary: 'Summary',
  parcel_delivery: 'Goods Receipts',
  record: 'Record',
  delivery: 'Receipt',
  stock: 'Stock',
  receive_purchase_order: 'Receive P.O.',
  remaining: 'Remaining',
  remaining_of_ordered: 'of {ordered}',
  main: 'Main',
  received: 'Received',
  set_priority: 'Set Priority',
  sales_period: 'Sales Period',
  final: 'Final',
  purchaseConfirmation: 'Are you sure you want to create the purchase order?',
  deliverables: 'Deliverables',
  received_back_orders: 'Received Back Orders',
  zip: 'Zip',
  finished: 'Finished',
  waiting: 'Waiting',
  comparing: 'Comparing',
  steps: 'Steps',
  archive: 'Archive',
  archives: 'Archives',
  archived: 'Archived',
  archiving: 'Archiving',
  archives_only: 'Archived Only',
  none_archives: 'None-Archives',
  roll_back: 'Roll back',
  roll_backing: 'Roll backing',
  default: 'Default',
  second: 'Second',
  all: 'All',
  manual: 'Manual',
  location: 'Location',
  update_priority_success_message: 'Priority updated successfully',
  name_required: 'Name is required',
  enter_banner_name: 'Enter banner name',
  content: 'Content',
  priority: 'Priority',
  available_quantity_is: 'Available quantity is',
  use_take_wity_quantity_warning: 'You can use Take With Quantity',
  drag_to_reorder: 'Drag to reorder',
  blogs: 'Blogs',
  preview: 'Preview',
  clear_all_content: 'Clear all content',
  user: 'User',
  users: 'Users',
  trending_jewelry: 'Trending Jewelry',
  trending_watch: 'Trending Watch',
  unused: 'Unused',
  only: 'Only',
  ticket: 'Ticket',
  tickets: 'Tickets',
  ticket_category: 'Ticket Category',
  non_purchasable: 'Non Purchasable',
  non_purchasable_suppress_price: 'Suppress Price',
  case_size: 'Case Size',
  carousels: 'Carousels',
  carousel: 'Carousel',
  watches: 'Watches',
  jewelry: 'Jewelry',
  slide: 'Slide',
  main_slides: 'Main Slides',
  sub_slides: 'Sub Slides',
  subtitle: 'Subtitle',
  main_image: 'Main Image',
  main_image_tooltip: 'Main image must match the product shown in Slide 1',
  product_image: 'Product Image',
  select_vendor: 'Select Vendor',
  brand: 'Brand',
  select_brand: 'Select Brand',
  select_category: 'Select Category',
  select_product: 'Select Product',
  exactly_three_sub_slides: 'Exactly 3 sub-slides are required',
  auto: 'Auto',
  sub_slide_title_tooltip: 'Shown on the website only. It does not affect which product is loaded.',
  search_in: 'Search in',
  order_fields: 'Order Fields',
  product_filters: 'Product Filters',
  base_configuration: 'Filter Choices',
  override_rules: 'Exceptions',
  product_type: 'Product Type',
  filters_enabled: 'filters enabled',
  overrides: 'Exceptions',
  unsaved_changes: 'Unsaved changes',
  discard: 'Discard',
  save_all: 'Save all',
  general_filter: 'General',
  specific_filter: 'Specific',
  filter: 'Filter',
  add_override: 'Add Exception',
  edit_override: 'Edit Exception',
  delete_override: 'Delete Exception',
  scope: 'Scope',
  target: 'Target',
  override_name: 'Exception name',
  starts_from_base: 'Starts from base',
  effective_preview: 'Effective preview',
  rule_skip: 'Skip',
  rule_add: 'Add',
  rule_remove: 'Remove',
  no_overrides_yet: 'No exceptions yet.',
  override_save_success: 'Exception saved successfully',
  override_delete_success: 'Exception deleted',
  base_config_save_success: 'Filter choices saved',
  no_target_selected: 'Select a scope target to continue.',
  no_rules_configured: 'Pick at least one rule (Add or Remove) before saving.',
  base_filters: 'Filter Choices',
  scope_category: 'Category',
  scope_subcategory: 'Subcategory',
  scope_subcategory2: 'Subcategory 2',
  scope_vendor: 'Vendor',
  discard_unsaved_confirm: 'You have unsaved changes. Discard them?',
  filter_phase4_disabled: 'Coming soon — not yet active on the website.',
  filter_phase4_short: 'Coming soon',
  base_config_scope_hint: 'Filters switched on here apply to every {type} page, with or without a brand or category selected. Use Exceptions to add or remove a filter for one brand or category.',
  rules_filter_column: 'Filter',
  rules_action_column: 'Action',
  no_scopes_available: 'Enable a general filter (Category, Subcategory, Subcategory 2, or Vendor) in Filter Choices before creating exceptions.',
  close: 'Close',
  printing_jewelry_tags: 'Printing Jewelry Tags',
  sending: 'Sending',
  sent_successfully: 'sent successfully',
  tags_printed_successfully: 'tags printed successfully',
  failed: 'failed',
  waiting_for_printer: 'Waiting for printer...',
  please_retry_printing: 'Please retry printing.',
  print_failed_message: 'Failed to send print request.',
  mail_label: 'Mail label',
  mail_label_sent_message: 'Mail label sent to the printer.',
  mail_label_save_first_message: 'Save the order before printing the mail label.',
  create_new_purchase_order: 'Create New P.O.',
  receive_purchase_order_title: 'Receive Purchase Order',
  find_purchase_order: 'Find P.O.',
  enter_purchase_order_number: 'Please enter a Purchase Order number.',
  purchase_order_not_found: 'Purchase Order not found.',
  items_qty_abbr: 'Items Qty.',
  total_qty_abbr: 'Total Qty.',
  received_qty_abbr: 'Received Qty.',
  total_cost: 'Total Cost',
  go_to_po: 'Go to PO',
  assigned_to_po: 'Assigned to PO',
  already_on_purchase_order: 'Already ordered on an active Purchase Order — it cannot be added to this one.',
  back_orders_selected: 'back orders selected for this Purchase Order',

  // Purchase order builder
  vendor_optional: 'Vendor (optional)',
  all_vendors: 'All vendors',
  qty_abbr: 'qty',
  added: 'Added',
  suggested_qty: 'Suggested qty',
  po_builder_live_hint: 'Results below update automatically as you change type or vendor.',
  po_type_change_cleared: 'Items chosen for the previous product type were removed from the cart.',
  po_vendor_change_cleared: 'Selected back orders were cleared for the new vendor selection.',
  po_source_back_order: 'Back order search',
  po_source_stock_sku: 'Stock SKU entry',
  po_source_min_max: 'Min/Max restock',
  back_order_search_hint: 'Click Search to find back-ordered items matching these filters.',
  stock_sku_search_placeholder: 'Enter a SKU or item name, then pick it below',
  stock_sku_keyboard_hint: '↑ ↓ to move · Enter to add · Esc to close — no mouse needed for repeat SKU entry.',
  stock_sku_empty: 'No items added yet. Search a SKU above and select it to add it here.',
  stock_sku_not_found: 'No matching SKU for this type and vendor.',
  min_max_none: 'No items are below minimum stock for this type and vendor.',
  min_max_below_minimum_one: '1 item is below minimum stock.',
  min_max_below_minimum_many: '{count} items are below minimum stock.',
  min_max_in_cart: 'Every suggested item is in the cart — remove the ones you do not want.',
  add_all_suggested: 'Add all suggested',
  remove_all_from_cart: 'Remove all from cart',
  po_cart: 'PO cart',
  show_po_cart: 'Show PO cart',
  hide_po_cart: 'Hide PO cart',
  po_cart_no_items: 'No items yet',
  po_cart_empty: 'Add items from any tab — they show up here, grouped by vendor.',
  po_cart_refresh_failed: 'The cart could not be calculated. The usual cause is an item with no cost price in inventory — remove the item you added last, or set its cost price first.',
  no_cost_price: 'No cost price',
  and_n_more: '+{count} more',
  po_cart_will_generate_one: 'Will generate 1 purchase order.',
  po_cart_will_generate_many: 'Will generate {count} purchase orders — one per vendor.',
  review_and_generate: 'Review & Generate',
  generate_without_review: 'Generate POs without review',
  back_to_editing: 'Back to editing',
  po_review_title_one: 'Review 1 purchase order',
  po_review_title_many: 'Review {count} purchase orders',
  po_review_subtitle: 'Grouped by vendor. Each group becomes its own purchase order.',
  generate_purchase_orders_one: 'Generate purchase order',
  generate_purchase_orders_many: 'Generate {count} purchase orders',
  po_confirm_title_one: 'Create 1 purchase order?',
  po_confirm_title_many: 'Create {count} purchase orders?',
  po_confirm_body_one: 'This creates a purchase order for {vendors} totalling {total}. This cannot be undone.',
  po_confirm_body_many: 'This creates {count} separate purchase orders — one for each vendor ({vendors}) — for a combined total of {total}. This cannot be undone.',
  po_confirm_ok_one: 'Yes, create PO',
  po_confirm_ok_many: 'Yes, create POs',
  po_generate_nothing: 'No purchase order was created — the items in the cart are no longer available to order.',
  po_success_title_one: '1 purchase order created',
  po_success_title_many: '{count} purchase orders created',
  po_success_subtitle: 'Each one is Confirmed — open it to receive goods when they arrive.',
  po_success_line_count_one: '1 item',
  po_success_line_count_many: '{count} items',
  view_po: 'View PO',
  generate_new_po: 'Generate new PO',
  go_to_purchase_orders: 'Go to purchase orders',

  // Shipping methods & rule engine
  shipping_methods: 'Shipping Methods',
  shipping_method: 'Shipping Method',
  shipping_method_kind: 'Type',
  key: 'Key',
  system: 'System',
  deleted: 'Deleted',
  restore: 'Restore',
  show_deleted: 'Show deleted',
  run: 'Run',
  rule: 'Rule',
  base_price: 'Base Price',
  price_override: 'Price Override',
  availability_rules: 'Availability Rules',
  available_everywhere: 'Available everywhere',
  rules_count: 'rules',
  rule_count_one: 'rule',
  rules_disabled: 'disabled',
  destination_country: 'Destination Country',
  destination_state: 'Destination State',
  min_cart_value: 'Minimum Cart Value',
  max_cart_value: 'Maximum Cart Value',
  cart_subtotal: 'Cart Subtotal',
  any_country: 'Any country',
  any_state: 'Any state',
  any_cart_value: 'Any cart value',
  cart_at_least: 'Cart of at least',
  cart_at_most: 'Cart of at most',
  no_minimum: 'No minimum',
  no_maximum: 'No maximum',
  uses_base_price: 'Uses base price',
  rule_label_placeholder: 'Optional note, e.g. "US lower 48"',
  store_pickup_is_free: 'Store pickup is always free, so the base price is fixed at $0.00.',
  min_cart_value_exceeds_max: 'A rule\'s minimum cart value cannot be greater than its maximum.',
  test_eligibility: 'Test a scenario',
  why_eligible: 'Why',
  matched_rule: 'Matched rule',
  fallback_applied: 'Fallback applied',
  no_eligible_shipping_methods: 'No shipping method is available for this destination and cart.',
  shipping_method_key_tooltip: 'Stored on every order placed with this method, so it cannot be changed once used.',
  shipping_method_key_format: 'Use 2–64 characters: letters, numbers and hyphens.',
  shipping_method_system_hint: 'This is a system method. Its key and type are fixed and it cannot be deleted, but the title, price, order, status and rules are all editable.',
  shipping_rules_semantics: 'A method is available when at least one rule matches. Within a rule, every field that is set must match; fields left blank match anything.',
  shipping_no_rules_hint: 'No rules — this method is available for every destination and every cart value.',
  checkout_notice_title: 'Checkout notice heading',
  checkout_notice: 'Checkout notice',
  checkout_notice_tooltip: 'Shown to the customer at checkout when this method is selected. Leave blank for no notice.',
  checkout_notice_title_placeholder: 'Shipping Cost to Be Confirmed',
  fallback_is_always_free: 'A fallback method is the "we will price this later" placeholder, so its price is fixed at $0.00.',
  fallback_has_no_rules: 'A fallback method cannot have availability rules.',
  fallback_has_no_rules_description: 'It applies whenever no other method is eligible, so a rule could only take that safety net away. To offer a to-be-priced option for one destination, create a normal delivery method at $0.00 with a country rule instead.',
  no_active_fallback: 'No active fallback shipping method.',
  no_rule_blocked_it: 'No rule blocked it',
  rule_effect: 'This rule',
  rule_effect_include: 'Includes',
  rule_effect_exclude: 'Excludes',
  rule_effect_include_hint: 'Offer this method where the conditions below match.',
  rule_effect_exclude_hint: 'Never offer this method where the conditions below match. An exclusion beats every include rule on this method, whatever the order.',
  exclusion_has_no_price: 'An exclusion removes the method, so there is no price to set.',
  exclusion_needs_condition: 'An exclusion rule needs at least one condition — country, state, or cart value. Without one it would remove this method from every destination.',
  no_active_fallback_description: 'Customers whose destination matches no rule can still check out — the system offers a "to be determined" option at $0.00 — but it uses built-in wording you cannot edit here. Activate a fallback method to control the message.',
} as const

export type TranslationKey = keyof typeof dictionary

export const translateDictionary: Record<string, string> = dictionary
